import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorLocationDistrict = () => {
  const listDistrict = useCallback((callback, payload) => {
    payload = {
      city_uid: payload,
    }
    ApiService.jsonRequest('/master-district/list', payload, (response) => {
      if (response.status_code === 200) {
        callback(response.data)
      }
    })
  }, [])

  return { listDistrict }
}

export default InteractorLocationDistrict
